import type { ReactNode } from 'react';
import { useHaptic } from '@/hooks/useHaptic';

interface CellProps {
  /** Иконка/эмодзи слева. */
  before?: ReactNode;
  /** Основной текст. */
  title: ReactNode;
  /** Подзаголовок. */
  subtitle?: ReactNode;
  /** Содержимое справа (значение, шеврон и т.д.). */
  after?: ReactNode;
  /** Делает ячейку кликабельной. */
  onClick?: () => void;
  /** Подсветить deструктивно (красным). */
  destructive?: boolean;
}

/**
 * Универсальная ячейка списка в стиле Telegram. Большой тач-таргет (~56px),
 * нижняя разделительная линия (применяется через :not(:last-child)).
 */
export function Cell({ before, title, subtitle, after, onClick, destructive }: CellProps): JSX.Element {
  const { selection } = useHaptic();
  const interactive = Boolean(onClick);

  return (
    <div
      role={interactive ? 'button' : undefined}
      onClick={
        interactive
          ? () => {
              selection();
              onClick?.();
            }
          : undefined
      }
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-md)',
        padding: 'var(--space-md) var(--space-lg)',
        minHeight: 56,
        cursor: interactive ? 'pointer' : 'default',
        color: destructive ? 'var(--tg-destructive)' : 'var(--tg-text)',
        borderBottom: '0.5px solid var(--tg-separator)',
      }}
    >
      {before && <div style={{ flexShrink: 0, fontSize: 22 }}>{before}</div>}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 'var(--font-md)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: 'var(--font-sm)', color: 'var(--tg-hint)', marginTop: 2 }}>{subtitle}</div>
        )}
      </div>
      {after && <div style={{ flexShrink: 0, color: 'var(--tg-hint)' }}>{after}</div>}
    </div>
  );
}
